module.exports = "/assets/aadcaadf414de83c200f203d0ebbf1a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/Z6.png
// module id = 3170
// module chunks = 0